import { OnInit } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { isFilteredBy } from '@core/utils/is-filtered-by';
import { chain } from 'lodash';
import { merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
var LinkedGroupsComponent = /** @class */ (function () {
    function LinkedGroupsComponent() {
    }
    LinkedGroupsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setDefaultPaginate();
        this.filterLinkedGroups();
        merge(this.searchInput.valueChanges, this.linkedGroups.valueChanges)
            .pipe(debounceTime(300))
            .subscribe(function () { return _this.filterLinkedGroups(); });
    };
    LinkedGroupsComponent.prototype.filterLinkedGroups = function () {
        var _this = this;
        this.filteredLinkedGroups = chain(this.linkedGroups.value)
            .filter(function (group) { return isFilteredBy({
            referenceValues: [group.name, group.description],
            includeValue: _this.searchInput.value
        }); })
            .sortBy('name')
            .value();
    };
    LinkedGroupsComponent.prototype.setDefaultPaginate = function () {
        this.lastPaginatedLinkedGroupIndex = 5;
        this.firstPaginatedLinkedGroupIndex = 1;
    };
    LinkedGroupsComponent.prototype.unlinkGroup = function (linkedGroup, filteredLinkedGroupIndex) {
        var linkedGroupIndex = this.linkedGroups.value.findIndex(function (group) { return group.id === linkedGroup.id; });
        this.linkedGroups.removeAt(linkedGroupIndex);
        this.filteredLinkedGroups.splice(filteredLinkedGroupIndex, 1);
        if (this.firstPaginatedLinkedGroupIndex > this.filteredLinkedGroups.length) {
            this.changePage();
        }
    };
    LinkedGroupsComponent.prototype.changePage = function (next) {
        if (next) {
            this.lastPaginatedLinkedGroupIndex += 5;
            this.firstPaginatedLinkedGroupIndex += 5;
            return;
        }
        if (!this.filteredLinkedGroups.length) {
            this.setDefaultPaginate();
            return;
        }
        this.lastPaginatedLinkedGroupIndex -= 5;
        this.firstPaginatedLinkedGroupIndex -= 5;
    };
    return LinkedGroupsComponent;
}());
export { LinkedGroupsComponent };
